import { useLang } from "../i18n";
import { scrollTo } from "./Nav";
import { ArrowUp } from "lucide-react";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer data-testid="footer" className="bg-terra text-ink border-t border-black/10">
      <div className="px-5 md:px-10 py-20 md:py-28">
        <p className="font-serif text-[clamp(2rem,6vw,5.5rem)] leading-none tracking-tighter max-w-5xl">
          {t.footer.tag}
        </p>
      </div>
      <div className="px-5 md:px-10 py-6 border-t border-black/15 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 font-mono text-[10px] uppercase tracking-[0.25em]">
        <span>© {new Date().getFullYear()} Jeanne Leveque — {t.footer.rights}</span>
        <span className="text-black/60">{t.footer.made}</span>
        <a
          href="https://www.instagram.com/jeanne.leveque.m"
          target="_blank"
          rel="noreferrer"
          data-testid="footer-instagram-link"
          className="hover:text-linen transition-colors duration-300"
        >
          @jeanne.leveque.m
        </a>
        <button
          data-testid="back-to-top-btn"
          onClick={() => scrollTo("#home")}
          className="flex items-center gap-2 hover:text-linen transition-colors duration-300"
        >
          Top <ArrowUp size={12} />
        </button>
      </div>
    </footer>
  );
}
